import { createTheme } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { pmagThemeOptions } from "@pmag/ui-components";
import { type PmagThemeOptions } from "@pmag/ui-components/lib/src/theme/pmagThemeOptions";
import { ConfigTheme, type InputAttributeConfig } from "@src/context/attributeConfig/AttributeConfigContext";
import { getDefaultOverrides, getThemeOptionsForTheme } from "@src/theme/theme.utils";
import { type FunctionComponent, type PropsWithChildren } from "react";

export interface ThemeProviderProps {
    inputAttributeConfig: InputAttributeConfig;
    shadowRootElement?: HTMLElement;
}

export const ThemeProvider: FunctionComponent<PropsWithChildren<ThemeProviderProps>> = ({ children, shadowRootElement, inputAttributeConfig }) => {
    const defaultOverridesWithThemeOptions = deepmerge(
        getDefaultOverrides(shadowRootElement),
        getThemeOptionsForTheme(inputAttributeConfig.theme ?? ConfigTheme.Default),
    );
    const themeOptions = deepmerge<PmagThemeOptions>(pmagThemeOptions, defaultOverridesWithThemeOptions);
    const theme = createTheme(themeOptions);

    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
